/* eslint-disable react/jsx-curly-newline */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-undef */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Eraser from 'apps/web_forms/assets/eraser.svg';
import Arrow from 'apps/web_forms/assets/diagonal-arrow.svg';
import SmallPencil from 'apps/web_forms/assets/pencil-small-stroke.svg';
import BigPencil from 'apps/web_forms/assets/pencil-big-stroke.svg';
import { COLORS } from 'apps/web_forms/utils/constants';

const StyledColorPicker = styled.div`
  .color-picker-container.picker-shown {
    transition: 0.25s;
    transition-timing-function: ease-out;
    transform: translateY(0);
    opacity: 1;
    z-index: 2;
  }

  .color-picker-container {
    opacity: 0;
    height: 8em;
    width: 2em;
    padding: 0.5em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
    cursor: pointer;
    z-index: -1;

    transform: translateY(20%);
    transition-timing-function: ease-in;
    transition: 0.2s;

    span {
      display: flex;
      justify-self: center;
      align-items: center;
      height: 1.5em;
      width: 1.5em;
      border-radius: 50%;
      margin-bottom: 0.3em;
      background-color: ${COLORS.lightgrey};
    }
  }
`;

const SignatureStrokePicker = ({ open, clickHandler }) => {
  const strokeSizes = {
    small: 2,
    big: 8,
    eraser: 15,
  };

  return (
    <StyledColorPicker>
      <div
        className={`${
          open
            ? 'color-picker-container picker-shown'
            : 'color-picker-container'
        }`}
      >
        <span
          style={{ border: '1px solid grey' }}
          onClick={() =>
            clickHandler({
              strokeSize: strokeSizes.small,
              openStroke: false,
              drawType: 'arrow',
            })
          }
          onKeyDown={() =>
            clickHandler({
              strokeSize: strokeSizes.small,
              openStroke: false,
              drawType: 'arrow',
            })
          }
          role="button"
          tabIndex={0}
          title="Arrow"
        >
          <Arrow />
        </span>
        <span
          style={{ border: '1px solid grey' }}
          onClick={() =>
            clickHandler({
              strokeSize: strokeSizes.eraser,
              activeColor: 'white',
              openStroke: false,
              drawType: 'free',
            })
          }
          onKeyDown={() =>
            clickHandler({
              strokeSize: strokeSizes.eraser,
              activeColor: 'white',
              openStroke: false,
              drawType: 'free',
            })
          }
          role="button"
          tabIndex={0}
          title="Eraser"
        >
          <Eraser />
        </span>
        <span
          style={{ border: '1px solid grey' }}
          onClick={() =>
            clickHandler({
              strokeSize: strokeSizes.big,
              openStroke: false,
              drawType: 'free',
            })
          }
          onKeyDown={() =>
            clickHandler({
              strokeSize: strokeSizes.big,
              openStroke: false,
              drawType: 'free',
            })
          }
          role="button"
          tabIndex={0}
          title="Big stroke"
        >
          <BigPencil />
        </span>
        <span
          style={{ border: '1px solid grey' }}
          onClick={() =>
            clickHandler({
              strokeSize: strokeSizes.small,
              openStroke: false,
              drawType: 'free',
            })
          }
          onKeyDown={() =>
            clickHandler({
              strokeSize: strokeSizes.small,
              openStroke: false,
              drawType: 'free',
            })
          }
          role="button"
          tabIndex={0}
          title="Small stroke"
        >
          <SmallPencil />
        </span>
      </div>
    </StyledColorPicker>
  );
};

SignatureStrokePicker.propTypes = {
  open: PropTypes.bool.isRequired,
  clickHandler: PropTypes.func.isRequired,
};

export default React.memo(SignatureStrokePicker);
